const blankBasicPlan = {
  items: [
    {
      componentName: 'groupCard',
      pageBreak: true,
      itemId: 'front',
      heading: '表紙',
      items: [
        {
          componentName: 'frontPageCard',
          itemId: 'front-title-author',
          heading: 'タイトル・作成者情報',
          data: {
            title: '事業計画書',
            subTitle: '',
            url: '',
            companyFormat: 'freelance',
            companyName: '',
            authorName: '',
            createDate: new Date()
          }
        }
      ]
    },
    {
      componentName: 'groupCard',
      pageBreak: false,
      itemId: 'motivation',
      heading: '創業の動機',
      items: [
        {
          componentName: 'textCard',
          itemId: 'motivation-inner',
          heading: '',
          data: {
            text: '',
            minRaws: 5
          }
        }
      ]
    },
    {
      componentName: 'groupCard',
      pageBreak: false,
      itemId: 'company-profile',
      heading: '会社概要',
      items: [
        {
          componentName: 'companyProfileCard',
          itemId: 'company-profile-inner',
          heading: '',
          data: {
            companyName: '',
            establishedDate: {
              year: '',
              month: ''
            },
            ceo: '',
            capital: '',
            address: {
              postalCode: '',
              postalDetail: ''
            },
            tel: '',
            url: '',
            businessContentsSimple: ''
          }
        }
      ]
  },
    {
      componentName: 'groupCard',
      pageBreak: false,
      itemId: 'president-info',
      heading: '経営者略歴等',
      items: [
        {
          componentName: 'nameAddressCard',
          itemId: 'president-info-name-address',
          heading: '氏名・現住所',
          data: {
            address: {
              postalCode: '',
              postalDetail: ''
            },
            dateOfBirth: {
              year: '',
              month: '',
              day: ''
            },
            name: '',
            gender: {
              kind: '',
              customText: ''
            }
          }
        },
        {
          componentName: 'jobHistoryCard',
          itemId: 'president-info-job-history',
          heading: '経歴',
          data: {
            histories: [
              {
                date: {
                  year: '',
                  month: ''
                },
                termDate: {
                  year: '',
                  month: ''
                },
                desc: ''
              },
              {
                date: {
                  year: '',
                  month: ''
                },
                termDate: {
                  year: '',
                  month: ''
                },
                desc: ''
              },
              {
                date: {
                  year: '',
                  month: ''
                },
                termDate: {
                  year: '',
                  month: ''
                },
                desc: ''
              },
              {
                date: {
                  year: '',
                  month: ''
                },
                termDate: {
                  year: '',
                  month: ''
                },
                desc: ''
              }
            ]
          }
        },
        {
          componentName: 'dateCard',
          itemId: 'president-info-opening-date',
          heading: '開業予定日',
          data: {
            date: {
              year: '',
              month: '',
              day: ''
            }
          }
        },
        {
          componentName: 'textCard',
          itemId: 'president-info-opening-place',
          heading: '開業予定地',
          data: {
            text: ''
          }
        },
        {
          componentName: 'manageExperienceCard',
          itemId: 'president-info-manage-experience',
          heading: '経営経験',
          data: {
            experienceStatus: 'inexperience',
            businessContents: '',
            stopDate: {
              year: '',
              month: ''
            }
          }
        },
        {
          componentName: 'licenceCard',
          itemId: 'president-info-licence',
          heading: '取得資格',
          data: {
            licencies: [
              { name: '' }
            ]
          }
        }
      ]
  },
    {
      componentName: 'groupCard',
      pageBreak: false,
      itemId: 'business-contents',
      heading: '事業内容',
      items: [
        {
          componentName: 'textCard',
          itemId: 'business-contents-purpose',
          heading: '業種業態',
          data: {
            text: ''
          }
        },
        {
          componentName: 'textCard',
          itemId: 'business-contents-open-day-hour',
          heading: '営業日・営業時間',
          data: {
            text: ''
          }
        },
        {
          componentName: 'textCard',
          itemId: 'business-contents-major-article',
          heading: '主要商品',
          data: {
            text: ''
          }
        },
        {
          componentName: 'textCard',
          itemId: 'business-contents-characteristic',
          heading: '特徴',
          data: {
            text: ''
          }
        },
        {
          componentName: 'textCard',
          itemId: 'business-contents-target',
          heading: '客層/販売先',
          data: {
            text: ''
          }
        },
        {
          componentName: 'textCard',
          itemId: 'business-contents-acquisition-strategy',
          heading: '集客戦略',
          data: {
            text: ''
          }
        }
      ]
  },
    {
      componentName: 'groupCard',
      pageBreak: false,
      itemId: 'market-environment',
      heading: '市場環境',
      items: [
        {
          componentName: 'textCard',
          itemId: 'market-environment-customer',
          heading: '顧客状況',
          data: {
            text: ''
          }
        },
        {
          componentName: 'textCard',
          itemId: 'market-environment-area-characteristics',
          heading: 'エリア特性',
          data: {
            text: ''
          }
        },
        {
          componentName: 'textCard',
          itemId: 'market-environment-competitive-advantage',
          heading: '競合優位性',
          data: {
            text: ''
          }
        }
      ]
  },
    {
      componentName: 'groupCard',
      pageBreak: false,
      itemId: 'operation',
      heading: '運営',
      items: [
        {
          componentName: 'stakeholdersCard',
          itemId: 'operation-business-partner',
          heading: '取引先',
          data: {
            stakeholders: [
              {
                name: '',
                address: '',
                shareRate: 0,
                salesOnCreditRate: 0,
                closingAndPayment: ''
              }
            ]
          }
        },
        {
          componentName: 'stakeholdersCard',
          itemId: 'operation-supplier',
          heading: '仕入先',
          data: {
            stakeholders: [
              {
                name: '',
                address: '',
                shareRate: 0,
                salesOnCreditRate: 0,
                closingAndPayment: ''
              }
            ]
          }
        },
        {
          componentName: 'stakeholdersCard',
          itemId: 'operation-subcontractor',
          heading: '外注先',
          data: {
            stakeholders: [
              {
                name: '',
                address: '',
                shareRate: 0,
                salesOnCreditRate: 0,
                closingAndPayment: ''
              }
            ]
          }
        },
        {
          //TODO:change card
          componentName: 'manpowerPlanningCard',
          itemId: 'operation-manpower-planning',
          heading: '人員計画',
          data: {
            positions: [
              {
                kind: '常勤役員',
                number: 0,
                detail: ''
              },
              {
                kind: '従業員',
                number: 0,
                detail: ''
              }
            ],
            salaryPayment: ''
          }
        }
      ]
  },
    {
      componentName: 'groupCard',
      pageBreak: false,
      itemId: 'borrowing',
      heading: 'お借入の状況',
      items: [
        {
          componentName: 'borrowerCard',
          itemId: 'borrowing-borrower',
          heading: '借入先',
          data: {
            borrowers: [
              {
                name: '',
                howUse: '',
                amount: '',
                repaymentAtYear: ''
              }
            ]
          }
        }
      ]
    },
    {
      componentName: 'groupCard',
      pageBreak: false,
      itemId: 'free',
      heading: '自由記述',
      items: [
        {
          componentName: 'textCard',
          itemId: '',
          heading: '',
          data: {
            text: ''
          }
        }
      ]
    },
    {
      componentName: 'groupCard',
      pageBreak: false,
      itemId: 'other-document',
      heading: '別紙資料',
      items: [
        {
          componentName: 'textCard',
          itemId: '',
          heading: '',
          data: {
            text: '・損益計算書\n・資金調達計画\n・投資計画',
            minRaws: 3
          }
        }
      ]
    }
  ]
}

export default blankBasicPlan
